import { render, staticRenderFns } from "./wechatAdidData.vue?vue&type=template&id=09fd9729&scoped=true&"
import script from "./wechatAdidData.vue?vue&type=script&lang=js&"
export * from "./wechatAdidData.vue?vue&type=script&lang=js&"
import style0 from "./wechatAdidData.vue?vue&type=style&index=0&id=09fd9729&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd9729",
  null
  
)

export default component.exports